import { gql } from "@apollo/client";
export const WINES_GET = gql `
  query WineGet($input: WineGetInput!) {
    WineGet(input: $input) {
      _id
      company {
        name
        websiteUrl
      }
      companyLogo {
        downloadUrl
      }
      companyLogoId
      bottlePhoto {
        downloadUrl
      }
      bottlePhotoId
      responsibleConsumptionPhotos {
        downloadUrl
      }
      responsibleConsumptionPhotosIds
      generalDetails {
        name
        brand
        vintageYear
        description {
          text
          values {
            lang
            text
          }
        }
        country
        alcoholByVolumePercentage
        bottleSizeInMl
        category
        varieties {
          text
          values {
            lang
            text
          }
        }
        ingredients {
          emphasized
          value {
            text
            values {
              lang
              text
            }
          }
        }
        allergens {
          emphasized
          value {
            text
            values {
              lang
              text
            }
          }
        }
        expirationDate
      }
      lotNumber
      nutritionalDetails {
        energyInKcal
        fatInGrams
        carbohydratesInGrams
        ofWhichSugarInGrams
        proteinInGrams
        saltInMilliGrams
      }
      wineryMemberId
      qrCode
      responsibleConsumptions
      sustainabilities
    }
  }
`;
